var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"services-item"},[_c('Button',{attrs:{"icon":"","to":_vm.route}},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }